<template>
  <div class="col-sm-12 col-lg-6 pd-5">
    <div class="card p-0 mb-0 shadow-dashboard">
      <div class="card-header bg-white d-flex justify-content-between align-items-center py-1 border-bottom" style="background-color: #a7bfc6 !important">
        <h5 class="font-bold mb-0 text-left">{{ statisticsItem[itemKey].data.name }}</h5>
        <div>
          <button @click="printReport" class="btn btn-sm border-0 font-bold text-dark">
             Print
          </button>
        </div>
      </div>
      
      <div class="card-body p-0">
        <div class="d-flex justify-content-end px-1 pt-1">
           <div class="d-flex align-items-center">
              <select 
                @change="$emit('onDateChange', statisticsItem[itemKey])"
                v-model="statisticsItem[itemKey].period_type" 
                class="form-control form-control-sm d-inline-block width-150 border-0 font-bold text-right"
                style="background: transparent"
              >
                <option v-for="(range, j) in timeRange" :key="j" :value="range.value">{{ range.name }}</option>
              </select>
           </div>
        </div>
        <div class="table-responsive">
          <table class="table table-sm table-striped table-hover mb-0">
            <thead>
              <tr class="text-dark">
                <th class="text-left py-1">Team Member</th>
                <th class="text-left py-1">Designation</th>
                <th class="text-left py-1">Department</th>
                <th class="text-right py-1">Total Hours</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="statisticsItem[itemKey].data.data.length === 0">
                <td colspan="4" class="text-center py-5 text-muted">
                    <i class="feather icon-info mr-50"></i> No activity logs found for this period.
                </td>
              </tr>
              <tr v-for="(item, index) in statisticsItem[itemKey].data.data" :key="index">
                <td class="text-left font-bold">{{ item.name }}</td>
                <td class="text-left small text-muted">{{ item.designation || '-' }}</td>
                <td class="text-left small text-muted">{{ item.department || '-' }}</td>
                <td @click="redirectToTimesheet(item)" class="text-right font-bold text-primary cursor-pointer">{{ commaFormat(item.amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";
import { useRoute, useRouter } from "vue-router";
import useDate from "@/services/utils/day";
import { useStore } from 'vuex';
import dashboardCardPdfPrinter from "@/services/utils/dashboardCardPdfPrinter";

const props = defineProps({
  statisticsItem: Object,
  page: Object,
  timeRange: Array,
  itemKey: String
});

const router = useRouter();
const route = useRoute();
const store = useStore();
const { commaFormat } = figureFormatter();
const { firstDateOfMonth, lastDateOfMonth } = useDate();
const { printCardReport } = dashboardCardPdfPrinter();

const navigate = (url) => {
  if (!url) return;
  router.push({ 
    name: url, 
    params: route.params, 
    query: { start: firstDateOfMonth, end: lastDateOfMonth } 
  });
};

const redirectToTimesheet = (item) => {
  const routeData = router.resolve({
    name: 'work-status-timesheet',
    params: {
      ...route.params,
      pageId: props.statisticsItem[props.itemKey].data.page_id,
    },
    query: {
      contact_profile_id: item.contact_profile_id,
      contact_profile_name: item.name,
      start: props.statisticsItem[props.itemKey].period_start,
      end: props.statisticsItem[props.itemKey].period_end
    }
  });
  window.open(routeData.href, '_blank');
};

const printReport = () => {
  const company = store.getters['company/getCompany'];
  const cardData = props.statisticsItem[props.itemKey];
  
  const headers = [
    { text: 'Team Member Name', width: '*' },
    { text: 'Designation', width: 'auto' },
    { text: 'Department', width: 'auto' },
    { text: 'Total Hours', width: 'auto', alignment: 'right' }
  ];
  
  const bodyData = cardData.data.data.map(item => [
    { text: item.name, bold: true },
    { text: item.designation || '-', fontSize: 9 },
    { text: item.department || '-', fontSize: 9 },
    { text: commaFormat(item.amount), alignment: 'right', bold: true }
  ]);
  
  printCardReport(
    `${cardData.data.name} Report`,
    headers,
    bodyData,
    company,
    `Period: ${cardData.period_type.replace(/_/g, ' ').toUpperCase()}`
  );
};
</script>

<style scoped>
.shadow-dashboard {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.05);
}
.font-bold {
  font-weight: 600;
}
.width-150 {
  width: 150px;
}
.cursor-pointer {
  cursor: pointer;
}
.text-primary {
  color: #7367f0 !important;
}
.bg-light {
    background-color: #f8f8f8 !important;
}
.ml-25 {
    margin-left: 0.25rem;
}
</style>
